import ErrorMessage from '@components/ErrorMessage'
import { vehiclesSelector } from 'dashboard-vehicles/selectors'
import { removeVehicle } from 'dashboard-vehicles/actions'
import ListItem from 'dashboard-vehicles/components/ListItem'
import { pendingSelector } from 'api/selectors'
import { useConfirm } from 'shared/hooks/useConfirm'
import { businessAccountSelector } from 'auth/selectors'

const VehicleList = ({ vehicles = [], pending, removeVehicle, isBusinessAccount }) => {
    const { confirm, ConfirmModal } = useConfirm()

    const error = pending.removeVehicle && pending.removeVehicle instanceof Error && pending.removeVehicle.message

    const onRemove = async vehicle => {
        if (isBusinessAccount) {
            const isConfirmed = await confirm()
            if (isConfirmed) {
                removeVehicle(vehicle)
            }
        } else {
            removeVehicle(vehicle)
        }
    }

    return (
        <>
            <ConfirmModal title="dashboard.vehicles.warning.title" text="dashboard.vehicles.warning.text" />
            <ul className="vehicles-list list-with-buttons">
                {vehicles.map(vehicle => (
                    <ListItem
                        {...vehicle}
                        onDelete={() => onRemove(vehicle)}
                        key={vehicle.id}
                        pending={pending[`removeVehicle-${vehicle.id}`] === true}
                    />
                ))}
                {error && <ErrorMessage className="vehicle-error" messages={[error]} />}
            </ul>
        </>
    )
}
const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector,
    pending: pendingSelector,
    isBusinessAccount: businessAccountSelector,
})

const mapDispatchToProps = {
    removeVehicle,
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleList)
